import React from 'react'

const Support = ({ color = 'currentColor' }: { color?: string }) => {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.4667 16.6583C16.55 17.35 15.8084 17.8333 15.2167 17.4749L11.725 15.3999C11.3417 15.3999 10.9667 15.375 10.6 15.325C11.2167 14.6 11.5834 13.6833 11.5834 12.6916C11.5834 10.3249 9.53337 8.40831 7.00004 8.40831C6.03337 8.40831 5.14171 8.68329 4.40004 9.16663C4.37504 8.95829 4.3667 8.74995 4.3667 8.53328C4.3667 4.74162 7.65837 1.66663 11.725 1.66663C15.7917 1.66663 19.0834 4.74162 19.0834 8.53328C19.0834 10.7833 17.925 12.775 16.1417 14.025L16.4667 16.6583Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6001 15.3251C9.77509 16.3251 8.46675 16.9667 7.00008 16.9667L4.82508 18.2584C4.45841 18.4834 3.99175 18.1751 4.04175 17.7501L4.25008 16.1084C3.13341 15.3334 2.41675 14.0917 2.41675 12.6917C2.41675 11.2251 3.20009 9.93342 4.40009 9.16676C5.14175 8.68342 6.03341 8.40845 7.00008 8.40845C9.53342 8.40845 11.5834 10.3251 11.5834 12.6917C11.5834 13.6834 11.2168 14.6001 10.6001 15.3251Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Support
